<template>
    <div>
        <envelope-recipient-definition-display-table
            v-bind:envelope="envelope"
            v-bind:envelope-definition="envelopeDefinition"
            class="mb-3" />
        <div class="d-flex align-items-center">
            <pc-button
                v-if="showRequestBtn"
                id="RequestESignaturesButton"
                v-bind:disabled="requestSignaturesDisabled"
                v-on:click="requestSignatures">
                {{ requestESignaturesButton }}
            </pc-button>
            <envelope-completed-badge v-if="envelopeElement_isStatusCompleted" />
            <pc-button
                v-if="envelopeElement_isStatusTerminal"
                id="StartOverButton"
                v-bind:disabled="readonly"
                v-on:click="startOver">
                {{ startOverButton }}
            </pc-button>
            <pc-button
                v-if="envelopeElement_hasEnvelope && !envelopeElement_isStatusTerminal"
                id="ManageRequestButton"
                v-bind:disabled="readonly"
                v-on:click="manageRequest">
                {{ manageRequestButton }}
            </pc-button>
            <pc-transition transition="fade">
                <div
                    v-if="showNotificationsResentBadge"
                    id="NotificationsResentBadgeText"
                    class="ms-2 text-bubble-success">
                    {{ notificationsResentBadgeText }}
                </div>
            </pc-transition>
            <pc-button
                v-if="showFetchUpdateBtn"
                v-bind:disabled="readonly"
                warning
                class="ms-2"
                v-on:click="fetchUpdate">
                <!-- cpr admin only -->
                Fetch Update
            </pc-button>
        </div>
    </div>
</template>
<script>
    import { envelopeElementMixin } from "./envelopeElementMixin";
    import envelopeRecipientDefinitionDisplayTable from "./envelopeRecipientDefinitionDisplayTable.vue";
    import envelopeCompletedBadge from "./envelopeCompletedBadge.vue";

    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        summaryContainer: {
            col: { xs: 12, md: 6 },
            always: "col ms-3 mb-3"
        }
    };

    export default {
        components: {
            envelopeRecipientDefinitionDisplayTable,
            envelopeCompletedBadge
        },
        mixins: [envelopeElementMixin],
        inject: {
            viewport: {
                from: "viewport",
                default: null
            },
            readonly: {
                from: "readonly",
                default: false
            }
        },
        props: {
            envelope: { type: Object, required: false, default: null },
            envelopeDefinition: { type: Object, required: true },
            requestable: { type: Boolean, required: true },
            showNotificationsResentBadge: { type: Boolean, required: false, default: false }
        },
        emits: ["request-signatures", "fetch-update", "manage-request", "start-over"],
        computed: {
            showFetchUpdateBtn() {
                return (
                    this.$app.loggedInUserIsCPAdmin &&
                    this.envelopeElement_hasEnvelope &&
                    !this.envelopeElement_isStatusTerminal
                );
            },
            showRequestBtn() {
                return !this.envelopeElement_hasEnvelope;
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            },
            requestSignaturesDisabled() {
                return this.readonly || !this.requestable;
            }
        },
        methods: {
            requestSignatures() {
                this.$emit("request-signatures");
            },
            fetchUpdate() {
                this.$emit("fetch-update");
            },
            manageRequest() {
                this.$emit("manage-request");
            },
            startOver() {
                this.$emit("start-over");
            }
        }
    };
</script>
